import Component from '../Component';
import Point from '../../Utility/Point';
import Interactable from '../Interactable';
import ColorFilter from '../ColorFilter';
import { MathHelper } from '../../Utility/MathHelper';
import RelativeButton from '../../Prototype/UI/BaseElements/RelativeButton';
import GameObject from '../../GameObject/GameObject';

/**
 * @deprecated
 * Interactable component should be used instead and
 * any functionality that is provided by this but not
 * provided in the former should be implemented there instead
 */
export default class ButtonComponent extends Component {
    public onClick: (a?: any) => any = undefined;
    public onClickAudio: string = 'button-press';
    public onClickAnimation: string = 'ButtonPress';
    public onReleaseAnimation: string = 'ButtonRelease';
    public baseScale: Point = new Point(1, 1);

    public attach(gameObject: GameObject<PIXI.Container>, params: any) {
        if (!gameObject.hasComponent(Interactable)) {
            gameObject.addComponent(Interactable, params);
        }
        super.attach(gameObject, params);
        gameObject.on('Enabled', (value: boolean) => (this.enabled = value));
    }
    public get enabled(): boolean {
        return this.gameObject.getComponent(Interactable).enabled;
    }
    public set enabled(value: boolean) {
        if (
            this.gameObject.getComponent(Interactable).tintOnDisable &&
            this.gameObject.hasComponent(ColorFilter)
        ) {
            this.gameObject.getComponent(
                ColorFilter
            ).saturation = MathHelper.clamp(Number(value), 0.2, 1);
        }

        if (this.gameObject instanceof RelativeButton) {
            this.gameObject.enabled = value;
        }
    }

    public setClickAudio(value: string) {
        this.onClickAudio = value;
    }
}
